import React from 'react'
import AnalyticsPage from '../AnalyticsPage';

const AnalyticsProvider = () => {
  return (
    <React.Fragment>
        <AnalyticsPage/>
    </React.Fragment>
  );
}

export default AnalyticsProvider;